import { http, IHttpResponse } from './BackendService';
import { DevPortalFile, FileUploadGenerateUrl } from '../interfaces/file-upload';
import { getAuth, postAuth } from './AuthHttpService';
import { authHeader } from '../helpers/auth-header';
import { DEV_PORTAL_API_URL } from '../app-config';

export const generateFilePresignedUrl = async (
  body: FileUploadGenerateUrl,
): Promise<IHttpResponse<DevPortalFile>> =>
  postAuth<DevPortalFile>(`${DEV_PORTAL_API_URL}/api/file/upload`, body);

export const fileReader = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);
    reader.onloadend = () => {
      const arrayBuffer = reader.result;
      resolve(arrayBuffer);
    };

    reader.onerror = () => {
      console.log('reader error');
      reject(null);
    };
  });

export const completeFileUpload = async (fileId: string): Promise<IHttpResponse<DevPortalFile>> =>
  getAuth<DevPortalFile>(`${DEV_PORTAL_API_URL}/api/file/${fileId}/complete`);

export const uploadFile = async (
  file: File,
  url: string,
): Promise<IHttpResponse<DevPortalFile>> => {
  const mHeaders = new Headers();
  mHeaders.append('Content-Type', 'image/png');

  const arrayBuffer = await fileReader(file);
  const args: RequestInit = {
    method: 'PUT',
    body: arrayBuffer,
    headers: mHeaders,
  };
  return http(new Request(url, args));
};

export const uploadPermissionsForm = async (
  appId: string,
  version: string,
  file: File,
): Promise<boolean> => {
  const body = file;

  const res = await fetch(
    new Request(`${DEV_PORTAL_API_URL}/api/v1/app/${appId}/version/${version}/permissions-form`, {
      method: 'put',
      body,
      headers: authHeader(),
    }),
  );

  if (res.ok) return true;

  return false;
};

export const fetchPermissionsForm = async (
  appId: string,
  version: string,
): Promise<Blob | undefined> => {
  const res = await fetch(
    new Request(`${DEV_PORTAL_API_URL}/api/v1/app/${appId}/version/${version}/permissions-form`, {
      method: 'get',
      headers: authHeader(),
    }),
  );

  if (res.ok) return res.blob();
};
